import { RSAA } from 'redux-api-middleware'
import { getApiPath, makeQueryParams } from 'sidecar-utility-library'
import { pathOr } from 'ramda'

import { types, initialState } from './types'

/**
 * Fetch pre-checked providers for member communications
 *
 * @param {string} categoryNames Category names tied to the pre-checked
 *   providers
 * @param {string} ratingArea User's rating area
 * @returns
 */
export const fetchMemberCommsPrecheckedProviders = (
  categoryNames = '',
  ratingArea = '',
) => {
  return {
    [RSAA]: {
      endpoint: getApiPath(
        'care',
        `cares/precheckedProviders${makeQueryParams({
          categoryNames,
          ratingArea,
        })}`,
      ),
      method: 'GET',
      types: [
        types.FETCH_MEMBER_COMMS_PRECHECKED_PROVIDERS_REQUEST,
        types.FETCH_MEMBER_COMMS_PRECHECKED_PROVIDERS_SUCCESS,
        types.FETCH_MEMBER_COMMS_PRECHECKED_PROVIDERS_ERROR,
      ],
    },
  }
}

export const clearMemberCommsPrecheckedProviders = () => ({
  type: types.CLEAR_MEMBER_COMMS_PRECHECKED_PROVIDERS,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_MEMBER_COMMS_PRECHECKED_PROVIDERS_REQUEST: {
      return {
        ...state,
        memberCommsPrecheckedProviders: {
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_MEMBER_COMMS_PRECHECKED_PROVIDERS_SUCCESS: {
      return {
        ...state,
        memberCommsPrecheckedProviders: {
          busy: false,
          entities: payload,
        },
      }
    }
    case types.FETCH_MEMBER_COMMS_PRECHECKED_PROVIDERS_ERROR: {
      return {
        ...state,
        memberCommsPrecheckedProviders: {
          busy: false,
          error: pathOr(
            'Something went wrong when fetching pre-checked providers',
            ['response', 'message'],
            payload,
          ),
        },
      }
    }
    case types.CLEAR_MEMBER_COMMS_PRECHECKED_PROVIDERS: {
      return {
        ...state,
        memberCommsPrecheckedProviders:
          initialState.memberCommsPrecheckedProviders,
      }
    }

    default:
      return state
  }
}
